import { render } from "./ScoreCard.vue?vue&type=template&id=51d0a6a0&scoped=true"
import script from "./ScoreCard.vue?vue&type=script&lang=js"
export * from "./ScoreCard.vue?vue&type=script&lang=js"

import "./ScoreCard.vue?vue&type=style&index=0&id=51d0a6a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d0a6a0"]])

export default __exports__